var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("¡Vaya!")]),_c('h3',[_vm._v("Parece ser que el servidor de Facebook no funciona correctamente,")]),_c('h3',[_vm._v("por favor intenta acceder más tarde.")]),_c('img',{attrs:{"src":require("../../assets/facebookdown.jpeg"),"alt":"Facebook Down","height":"200"}})])
}]

export { render, staticRenderFns }